import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-otp-header-field',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './otp-header-field.component.html',
    styleUrl: './otp-header-field.component.css'
})
export class OtpHeaderFieldComponent {
  @Input() fields: any;
  @Input() workflowData: any;
}
